"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var actionTypes = _interopRequireWildcard(require("./actionTypes"));

var actions = _interopRequireWildcard(require("./actions"));

var constants = _interopRequireWildcard(require("./constants"));

var api = _interopRequireWildcard(require("./api"));

var _reducer = _interopRequireWildcard(require("./reducer"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = {
  api: api,
  reducer: _reducer.default,
  actionTypes: actionTypes,
  actions: actions,
  constants: constants,
  reducersByKey: {
    currentPlace: _reducer.currentPlace,
    currentPlaceParent: _reducer.currentPlaceParent,
    city: _reducer.city,
    region: _reducer.region,
    suggestions: _reducer.suggestions,
    slug: _reducer.slug,
    placeId: _reducer.placeId,
    latitude: _reducer.latitude,
    longitude: _reducer.longitude,
    bbox: _reducer.bbox,
    placeType: _reducer.placeType,
    isEnglishLanguage: _reducer.isEnglishLanguage,
    topSuggestions: _reducer.topSuggestions,
    cityBlurb: _reducer.cityBlurb,
    trendingSearchCities: _reducer.trendingSearchCities,
    isWaitingForLocation: _reducer.isWaitingForLocation,
    isUsingCurrentLocation: _reducer.isUsingCurrentLocation,
    locationDenied: _reducer.locationDenied,
    isOnline: _reducer.isOnline
  }
};
exports.default = _default;
//# sourceMappingURL=index.js.map